
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M3.97445 10.7097L2 13.8689L9.92102 17.028L12.151 13.7992M3.97445 10.7097L12.151 13.7992M3.97445 10.7097L12.151 8.73529L20.3275 10.7097M12.151 13.7992V23.4624M12.151 13.7992L20.3275 10.7097M12.151 13.7992L14.381 17.028L22 13.6417L20.3275 10.7097M12.151 23.4624L3.97445 18.7004V14.6563M12.151 23.4624L20.3275 18.7004V14.3851"></path><path opacity="0.5" d="M12.0747 5.70592C14.385 5.57801 16.3748 3.84566 17.1238 2.02752"></path><path opacity="0.5" d="M20.2655 1.74053C20.1105 3.19719 19.5937 3.65426 18.5805 4.23904"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiNodata",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
